<script>
// Extensions
import View from "@/views/home/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "About",

  metaInfo: { title: "About Us" },

  extends: View,

  mixins: [LoadSections(["hero-alt", "aboutus", "info"])],

  props: {
    id: {
      type: String,
      default: "about",
    },
  },
};
</script>
